export default __webpack_public_path__ + "static/media/aws-cp.2fa1fd9b.png";